import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


//const domain_path = "https://hkclubs.samsung.com";
const domain_path = "https://hkclubs.local.opentide.com.cn";
// 1. 圖片路徑常數
const IMAGES1 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_01.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_01.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_01.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_01.jpg",
  }
};

const IMAGES2 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_02.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_02.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_02.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_02.jpg",
  }
};

const IMAGES3 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_03.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_03.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_03.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_03.jpg",
  }
};

const IMAGES4 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_04.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_04.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_04.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_04.jpg",
  }
};

const IMAGES5 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_05.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_05.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_05.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_05.jpg",
  }
};

const IMAGES6 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_06.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_06.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_06.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_06.jpg",
  }
};

const IMAGES7 = {
  desktop: {
    en: domain_path + "/Media/ai_image/desktop_AI_EN_07.jpg",
    zh: domain_path + "/Media/ai_image/desktop_AI_TC_07.jpg",
  },
  mobile: {
    en: domain_path + "/Media/ai_image/mobile_AI_EN_07.jpg",
    zh: domain_path + "/Media/ai_image/mobile_AI_TC_07.jpg",
  }
};

const EventRegistrationLanding = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const isChinese = i18n.language === "hk";
  const langKey = isChinese ? "zh" : "en";
  const urllangKey = isChinese ? "hk" : "hk_en";

  const isMobile = useMediaQuery("(max-width:768px)");

  const currentImageSrc1 = isMobile ? IMAGES1.mobile[langKey] : IMAGES1.desktop[langKey];
  const currentImageSrc2 = isMobile ? IMAGES2.mobile[langKey] : IMAGES2.desktop[langKey];
  const currentImageSrc3 = isMobile ? IMAGES3.mobile[langKey] : IMAGES3.desktop[langKey];
  const currentImageSrc4 = isMobile ? IMAGES4.mobile[langKey] : IMAGES4.desktop[langKey];
  const currentImageSrc5 = isMobile ? IMAGES5.mobile[langKey] : IMAGES5.desktop[langKey];
  const currentImageSrc6 = isMobile ? IMAGES6.mobile[langKey] : IMAGES6.desktop[langKey];
  const currentImageSrc7 = isMobile ? IMAGES7.mobile[langKey] : IMAGES7.desktop[langKey];

  const handleImageClick = (code, track) => {
    if (code === "all") {
      navigate("/galaxy_ai_academy?type=event_registration&lang=" + urllangKey + "&utm_source=web_pod&utm_medium=overview&utm_campaign=ai_academy");
    } else {
      navigate("/event_form?code=" + code + "&lang=" + urllangKey + "&utm_source=web_pod&utm_medium=" + track + "=ai_academy");
    }
  };

  const baseImageStyle = {
    width: "100%",
    maxWidth: "100%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    padding: 0,
  };

  // 電腦版並排容器樣式
  const rowBoxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    maxWidth: "100%", // 可以限制最大寬度防止大螢幕過度拉伸
    margin: "0 auto",
    padding: 0,
  };

  navigate("/galaxy_ai_academy?type=event_registration&workshop_product=6&utm_source=web_pod&utm_medium=overview&utm_campaign=ai_academy");

  return null;

  return (
    <Box>
      {isMobile ? (
        /* 手機版：所有圖片垂直單欄堆疊 */
        <Box
          className="interstitial-landing-container"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            //minHeight: "calc(100vh - 160px)",
            backgroundColor: "#fff",
            padding: 0,
          }}
        >
          <img
            src={currentImageSrc1}
            alt="Event Registration Part 1"
            onClick={() => handleImageClick("all")}
            style={{
              ...baseImageStyle,
              paddingTop: "80px",
              cursor: "pointer",
            }}
          />
          <img
            src={currentImageSrc2}
            alt="Event Registration Part 2"
            style={baseImageStyle}
          />
          <img
            src={currentImageSrc3}
            alt="Event Registration Part 3"
            onClick={() => handleImageClick("smart-career-newbies", "smart_career_newbies")}
            style={{
              ...baseImageStyle,
              cursor: "pointer",
            }}
          />
          <img
            src={currentImageSrc4}
            alt="Event Registration Part 4"
            onClick={() => handleImageClick("new-gen-intelligence", "new_gen_int")}
            style={{
              ...baseImageStyle,
              cursor: "pointer",
            }}
          />
          <img
            src={currentImageSrc5}
            alt="Event Registration Part 5"
            onClick={() => handleImageClick("senior-ai-wisdom", "ai_wisom")}
            style={{
              ...baseImageStyle,
              cursor: "pointer",
            }}
          />
          <img
            src={currentImageSrc6}
            alt="Event Registration Part 6"
            onClick={() => handleImageClick("advanced-ai-commanders", "advanced_ai")}
            style={{
              ...baseImageStyle,
              cursor: "pointer",
            }}
          />
          <img
            src={currentImageSrc7}
            alt="Event Registration Part 7"
            style={{
              ...baseImageStyle,
              cursor: "pointer",
            }}
          />
        </Box>
      ) : (
        /* 🛠️ 電腦版 (Desktop)：自訂並排與獨佔版面 */
        <Box
          className="interstitial-landing-container-desktop"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            minHeight: "calc(100vh - 160px)",
            backgroundColor: "#fff",
            padding: 0,
            paddingTop: "80px", // 統一電腦版的頂部留白
          }}
        >
          {/* Row 1: Image 1 獨佔一列 */}
          <Box sx={{ width: "100%", maxWidth: "100%" }}>
            <img
              src={currentImageSrc1}
              alt="Event Registration Part 1"
              onClick={() => handleImageClick("all")}
              style={{
                ...baseImageStyle,
                cursor: "pointer",
              }}
            />
          </Box>

          {/* Row 2: Image 2 獨佔一列 */}
          <Box sx={{ width: "100%", maxWidth: "100%" }}>
            <img
              src={currentImageSrc2}
              alt="Event Registration Part 2"
              style={baseImageStyle}
            />
          </Box>

          {/* Row 3: Image 3 & 4 緊密並排 */}
          <Box sx={rowBoxStyle}>
            <img
              src={currentImageSrc3}
              alt="Event Registration Part 3"
              onClick={() => handleImageClick("smart-career-newbies", "smart_career_newbies")}
              style={{
                ...baseImageStyle,
                cursor: "pointer",
              }}
            />
            <img
              src={currentImageSrc4}
              alt="Event Registration Part 4"
              onClick={() => handleImageClick("new-gen-intelligence", "new_gen_int")}
              style={{
                ...baseImageStyle,
                cursor: "pointer",
              }}
            />
          </Box>

          {/* Row 4: Image 5 & 6 緊密並排 */}
          <Box sx={rowBoxStyle}>
            <img
              src={currentImageSrc5}
              alt="Event Registration Part 5"
              onClick={() => handleImageClick("senior-ai-wisdom", "ai_wisom")}
              style={{
                ...baseImageStyle,
                cursor: "pointer",
              }}
            />
            <img
              src={currentImageSrc6}
              alt="Event Registration Part 6"
              onClick={() => handleImageClick("advanced-ai-commanders", "advanced_ai")}
              style={{
                ...baseImageStyle,
                cursor: "pointer",
              }}
            />
          </Box>

          {/* Row 1: Image 1 獨佔一列 */}
          <Box sx={{ width: "100%", maxWidth: "100%" }}>
            <img
              src={currentImageSrc7}
              alt="Event Registration Part 7"
              style={{
                ...baseImageStyle,
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default EventRegistrationLanding;